import React, { useState, useEffect } from 'react';
import CreditLimitView from 'partial/OfferManager/modules/CreditLimit/CreditLimitView';
import {
  CLICK,
  buildAttributes,
} from 'partial/OfferManager/modules/staticModule';
import { useLinkHandler } from 'hook/event.hook';
import { useSeenModulePixel, useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CREDIT_LIMIT_ACTION } from 'types/morph.pagePosition.constants';

const getTotalLimit = (offers, setTotalLimit) => {
  let totalCreditLimit = 0;
  const numOffers = offers.length > 3 ? 3 : offers.length;
  for (let n = 0; n < numOffers; n++) {
    let offer = offers[n];
    if (
      offer.type !== 'SEE_ALL_CARDS' &&
      !offer.hideCreditLimit &&
      offer.predictedCreditLimit > 0
    ) {
      totalCreditLimit += offer.predictedCreditLimit;
    }
  }
  setTotalLimit(totalCreditLimit);
};

function CreditLimitController(props) {
  const [totalLimit, setTotalLimit] = useState(0);
  const onLinkClickCallback = useLinkHandler(props.eventHandler);
  const onClickApply = () => {
    props.eventHandler(
      CLICK,
      buildAttributes(props, {
        'Click Type': 'Apply',
      }),
    );
  };
  const atr = getViewModuleTrackingAttributes(
    CREDIT_LIMIT_ACTION,
    props.modulePosition,
  );

  useViewModule(atr);
  const seenPixel = useSeenModulePixel(atr);

  useEffect(() => {
    if (!totalLimit && props.offers) {
      getTotalLimit(props.offers, setTotalLimit);
    }
    //eslint-disable-next-line
  }, [totalLimit, props.offers]);

  return (
    <CreditLimitView
      totalLimit={totalLimit}
      onClickApply={onClickApply}
      onLinkClickCallback={onLinkClickCallback}
      seenPixel={seenPixel}
      {...props}
    />
  );
}

export default CreditLimitController;
